import Vue from 'vue';

export const errorParser = (error) => {
  let errorMsg = 'An unknown error occurred';

  if (error.response && error.response.data) {
    const data = error.response.data;
    const { message, errors } = data;

    if (errors && typeof errors === 'object') {
      // Format: "field: error message"
      const fieldMessages = Object.entries(errors).map(
        ([field, messages]) => `${field}: ${messages.join(', ')}`
      );
      errorMsg = fieldMessages.join(' | ') || message || error.message;
    } else if (Array.isArray(message)) {
      errorMsg = message.join(', ');
    } else {
      errorMsg = message || error.message;
    }
  } else if (error.message) {
    errorMsg = error.message;
  } else if (typeof error === 'string') {
    errorMsg = error;
  }

  return errorMsg;
};



Vue.prototype.$errorParser = errorParser

export default errorParser
